import { useEffect, useState } from "react";

const desktopImg = new URL("@/assets/desktop.jpg", import.meta.url).href;
const holdstationSvg = new URL("@/assets/holdstation.svg", import.meta.url)
  .href;

export function Loading() {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setProgress((prev) => {
        if (prev >= 100) {
          return 100;
        }
        return prev + 1;
      });
    }, 25);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="relative h-screen w-screen bg-[center_50%] bg-no-repeat bg-cover overflow-hidden"
      style={{ backgroundImage: `url(${desktopImg})` }}
    >
      {/* Frosted overlay */}
      <div className="absolute inset-0 bg-black/30 backdrop-blur-xl" />

      {/* Masked background layer */}
      <div
        className="absolute inset-0 bg-[center_50%] bg-no-repeat bg-cover"
        style={{
          backgroundImage: `url(${desktopImg})`,
          maskRepeat: "no-repeat",
          WebkitMaskRepeat: "no-repeat",
          maskPosition: "center",
          WebkitMaskPosition: "center",
          maskImage: `url(${holdstationSvg})`,
          WebkitMaskImage: `url(${holdstationSvg})`,
        }}
      />

      {/* Centered content */}
      <div className="relative z-10 flex h-full w-full flex-col items-center justify-center">
        {/* Progress bar */}
        <div className="absolute top-[56%] w-44 h-[6px] rounded bg-white/30">
          <div
            className="h-[6px] rounded-[90px] bg-white transition-all duration-100"
            style={{ width: `${progress}%` }}
          />
        </div>
      </div>
    </div>
  );
}
